import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useLockBodyScroll from "../../../hooks/useLockBodyScroll";

// Bulk "Promeni Broj Vežbača" action for TimeslotsSection.jsx — one number, applied to every
// selected timeslot's max_bookings on save. `initialValue` is pre-computed by the caller: the
// shared value when every selected slot already has the same max_bookings, otherwise the
// default ceiling (7), so the input starts blank-but-meaningful either way instead of always
// defaulting to 7 regardless of what's actually selected.
const MaxBookingsPopup = ({
  initialValue,
  onConfirm,
  onClose,
  saving,
  // Same "modal" vs "panel" convention as EmployeePopup.jsx on this same screen.
  variant = "modal",
}) => {
  const [value, setValue] = useState(String(initialValue));
  useLockBodyScroll(variant === "modal");

  const numericValue = Number(value);
  const isValid = value !== "" && Number.isInteger(numericValue) && numericValue > 0;

  const content = (
    <>
      <div className="hf-tm-emp-header">
        <h2 className="hf-tm-emp-title">Promeni broj vežbača</h2>
        <button
          type="button"
          className="hf-tm-emp-close"
          onClick={onClose}
          aria-label="Zatvori"
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </button>
      </div>

      <div className="hf-tm-emp-counter">
        Novi broj se primenjuje na sve izabrane termine.
      </div>

      <div className="hf-tm-max-bookings-field">
        <input
          type="number"
          min="1"
          className="hf-tm-max-bookings-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          autoFocus
        />
      </div>

      <div className="hf-tm-emp-footer">
        <button
          type="button"
          className="hf-tm-emp-cancel"
          onClick={onClose}
          disabled={saving}
        >
          Otkaži
        </button>
        <button
          type="button"
          className="hf-tm-emp-confirm"
          disabled={!isValid || saving}
          onClick={() => onConfirm(numericValue)}
        >
          Sačuvaj
        </button>
      </div>
    </>
  );

  if (variant === "panel") {
    return <div className="hf-tm-emp-panel-body">{content}</div>;
  }

  return (
    <div className="hf-tm-emp-overlay">
      <div className="hf-tm-emp-modal">{content}</div>
    </div>
  );
};

export default MaxBookingsPopup;
